import { take, race, call } from 'redux-saga/effects';

import {
  processingAggregatesStart,
  processingAggregatesStop,
} from '@store/filing/aggregates/aggregates.reducer';

import { pollProcessingAggregatesSaga } from '../pollProcessingAggregatesSaga';

export const watchPollProcessingAggregatesSaga = function* () {
  while (true) {
    const payload = yield take(processingAggregatesStart.type);

    yield race([call(pollProcessingAggregatesSaga, payload), take(processingAggregatesStop.type)]);
  }
};
